<template>
	<div id="page" class="BusinessLP">
		<section
			class="category_top_banner s_cat_in_top_banner cover"
			v-lazy:background-image="
				pageData.acf.titlebar.bg && $mq !== 'mobile'
					? pageData.acf.titlebar.bg
					: pageData.acf.titlebar.bg_mobile
			"
		>
			<div class="container" :class="{ 'white-text': pageData.acf.titlebar.white_text }">
				<h1 class="title">{{ pageData.acf.titlebar.title ? pageData.acf.titlebar.title : pageData.title }}</h1>
				<div class="banner-text">
					{{ pageData.acf.titlebar.subtitle ? pageData.acf.titlebar.subtitle : "" }}
				</div>
				<button class="btn red-btn" @click="scrollToForm">
					{{pageData.acf.button_text}}
					<arrowLeft />
				</button>
			</div>
			<div class="bn_corner" v-if="$mq !== 'mobile'"></div>
		</section>
		<div class="container">
			<div class="main page">
				<div class="blocks">
					<div
						class="block"
						v-for="block in pageData.acf.blocks"
						:key="block.title"
						v-bind:style="{ background: block.bg_color }"
					>
						<img class="block-bg-image" :src="block.bg_image" v-if="block.bg_image" />
						<img class="block-image" :src="block.image" />
						<div class="block-content">
							<div class="block-title">{{ block.title }}</div>
							<div class="block-text" v-html="block.content"></div>
						</div>
					</div>
					<div class="block testimonial-block">
						<Slick ref="slider" :options="slickOptions" v-if="pageData.acf.testimonials">
							<div
								v-for="(item, i) in pageData.acf.testimonials"
								:key="i"
								class="testimonial-item-container"
							>
								<div class="testimonial-item">
									<div class="text" v-html="item.content"></div>
									<h4 class="name">{{ item.title }}</h4>
								</div>
							</div>
						</Slick>
					</div>
				</div>
				<div class="center-button">
					<button class="btn red-btn" @click="scrollToForm">
						{{pageData.acf.button_text}}
						<arrowLeft />
					</button>
				</div>
				<div class="images-slider">
					<Slick ref="slider" :options="slickOptionsImages" v-if="pageData.acf.slider">
						<div v-for="(item, i) in pageData.acf.slider" :key="i" class="slider-item-container">
							<div class="slider-item">
								<div class="slider-item-inner">
									<img :src="item.image.sizes.medium_large" />
								</div>
							</div>
						</div>
						<div v-for="(item, i) in pageData.acf.slider" :key="i" class="slider-item-container">
							<div class="slider-item">
								<div class="slider-item-inner">
									<img :src="item.image.sizes.medium_large" />
								</div>
							</div>
						</div>
					</Slick>
				</div>
				<div class="page-bottom">
					<div class="row">
						<div class="col-sm-6">
							<div class="bottom-title" v-html="pageData.acf.form_area.title"></div>
							<div class="serv_box clearfix">
								<div class="right serv_wrap clearfix">
									<div class="right serv_item">
										<a
											:href="
												'tel:' + [pageData.acf.contact.phone ? pageData.acf.contact.phone : '']
											"
										>
											<span class="serv_icon ease">
												<PHONE />
											</span>
											<span class="serv_tx">{{
												pageData.acf.contact.phone ? pageData.acf.contact.phone : ""
											}}</span>
										</a>
									</div>
									<div
										class="right serv_item hasTooltip"
										title="יש להוסיף את המספר לרשימת אנשי הקשר (אפשר לקרוא לנו 'כרמלה') ואז לשלוח לנו הודעה"
									>
										<a
											:href="
												'https://api.whatsapp.com/send?phone=972' +
												pageData.acf.contact.mobile.replace(/\D/g, '')
											"
										>
											<span class="serv_icon ease">
												<WHATSAPP />
											</span>
											<span class="serv_tx">{{ pageData.acf.contact.mobile }}</span>
										</a>
									</div>
									<div class="right serv_item">
										<a :href="'mailto:' + pageData.acf.contact.email">
											<span class="serv_icon ease">
												<MAIL />
											</span>
											<span class="serv_tx">{{ pageData.acf.contact.email }}</span>
										</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="bottom-title">או שפשוט תשאירו לנו פרטים ונחזור אליכם בהקדם</div>
							<div v-html="pageData.acf.form_area.form" v-if="!formSent" class="contact_form"></div>

							<div class="sent" v-if="formSent">
								<div class="img">
									<OK />
								</div>
								<p class="bold">ההודעה נשלחה!</p>
								<p class="">ניצור אתך קשר בהקדם</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import arrowLeft from "@/assets/img/arrow_l.svg";
	import PHONE from "@/assets/img/phone.svg";
	import MAIL from "@/assets/img/mail.svg";
	import WHATSAPP from "@/assets/img/whatsapp.svg";
	import OK from "@/assets/img/ok.svg";
	import Slick from "vue-slick";

	export default {
		data() {
			return {
				title: "",
				content: "",
				page: "",
				globalOptions: window.wpData.globalOptions,
				formSent: false,
				slickOptions: {
					slidesToShow: 1,
					rtl: true,
					dots: true,
					arrows: false,
					// nextArrow: true,
					// prevArrow: true,
					adaptiveHeight: true,
					infinite: true,
					centerMode: false,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
					pauseOnHover: true,
					pauseOnFocus: true,
				},
				slickOptionsImages: {
					slidesToShow: 3,
					rtl: true,
					dots: true,
					arrows: false,
					adaptiveHeight: true,
					infinite: true,
					centerMode: true,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 4000,
					pauseOnHover: false,
					pauseOnFocus: false,
					// centerPadding: '150px',
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
				},
			};
		},
		methods: {
			scrollToForm() {
				document.querySelector(".contact_form").scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
			},
		},
		computed: {
			pageData() {
				if (typeof wpData.pageData != "object") {
					return JSON.parse(wpData.pageData);
				}
				return wpData.pageData;
			},
		},
		created() {
			this.$modal.hide("login-modal");
		},
		mounted() {
			document.addEventListener("wpcf7mailsent", (e) => {
				this.formSent = true;
				$(document.body).find(".red-btn").removeClass("loading");
				setTimeout(() => {
					document.querySelector("#scroll-to-after-submit").scrollIntoViewIfNeeded();
				}, 500);
			});

			$(".wpcf7").on("wpcf7invalid", function (e) {
				$(document.body).find(".red-btn").removeClass("loading");
				setTimeout(() => {
					document.querySelector("#scroll-to-after-submit").scrollIntoViewIfNeeded();
				}, 500);
			});

			document.querySelector(".scrollToForm").addEventListener("click", (e) => {
				e.preventDefault();
				this.scrollToForm();
			});

			document.querySelector(".wpcf7-form").addEventListener("submit", (e) => {
				$(document.body).find(".red-btn").addClass("loading");
			});

			$('select.wpcf7-select[name="menu"] option:first-child').prop("disabled", true);
		},
		components: {
			Slick,
			OK,
			WHATSAPP,
			MAIL,
			PHONE,
			arrowLeft,
		},
	};
</script>
<style lang="scss" scoped>
	#page {
		.category_top_banner {
			padding-top: 0;
			height: 372px;

			.container {
				height: calc(100% - 30px);
				display: flex;
				flex-direction: column;
				justify-content: center;
			}

			h1 {
				margin: 0;
				font-size: 50px;
				font-family: "raanancondensed", arial, sans-serif;
			}

			.banner-text {
				height: auto;
				color: #000;
				font-family: simpler, arial, sans-serif;
				font-size: 20px;
				line-height: 30px;
				margin-bottom: 20px;
				max-width: 700px;
			}
		}

		.red-btn {
			background: #ef4134;
			color: #ffffff;
			font-size: 20px;
			align-self: flex-start;
			display: flex;
			align-items: center;
			gap: 10px;
			border-radius: 10px;
			padding: 11px 20px;
			transition: 300ms ease all;
			position: relative;

			&:hover {
				background: #c9372c;
			}

			svg {
				fill: #fff;
				height: 15px;
				width: auto;
			}
		}

		.blocks {
			$gap: 20px;

			display: flex;
			gap: $gap;
			flex-wrap: wrap;
			margin-bottom: 3em;

			.block {
				flex: 0 0 33.33%;
				max-width: calc(33.33% - #{$gap});
				border-radius: 0 0 30px 30px;
				overflow: hidden;
				padding: 15px 10px;
				position: relative;
				min-height: 380px;

				.block-bg-image {
					position: absolute;
					z-index: -1;
					top: 0;
					bottom: 0;
					right: 0;
					left: 0;
					transition: 500ms ease all;
					object-fit: cover;
					width: 100%;
					height: 100%;
					object-position: left;
				}

				.block-image {
					margin-bottom: 25px;
					height: 165px;
					transition: 500ms ease all;
					transform-origin: right;
				}

				.block-content {
					padding: 0 15px;
					transition: 500ms ease all;

					.block-title {
						color: #1e824c;
						font-family: "raanancondensed", arial, sans-serif;
						font-size: 35px;
						font-style: normal;
						font-weight: 300;
						line-height: 21px; /* 60% */
						margin-bottom: 10px;
					}

					.block-text {
						color: #000;
						text-align: right;
						font-size: 16px;
						font-style: normal;
						font-weight: 400;
						line-height: 20px;

						a {
							color: #000;
							text-decoration: underline;
						}
					}
				}

				@media (min-width: 768px) {
					&:hover {
						.block-bg-image {
							transform: scale(1.1);
						}

						.block-image {
							transform: scale(1.15);
						}

						.block-content {
							margin-top: 15px;
						}
					}
				}
			}

			@media (min-width: 1400px) {
				.block {
					min-height: 350px;
				}
			}
		}

		.page-bottom {
			background: #fffbfb;
			border-radius: 0 0 30px 30px;
			padding: 20px 185px 30px 50px;
			position: relative;
			margin-bottom: 4em;

			&:before {
				content: "";
				position: absolute;
				height: 120px;
				width: 170px;
				top: -12px;
				right: -20px;
				background: url("/wp-content/themes/carmella/carmella-vue/src/assets/img/plane.png") no-repeat
					center/contain;
			}

			.bottom-title {
				color: #1e824c;
				font-size: 20px;
				font-style: normal;
				font-weight: 700;
				line-height: 30px; /* 150% */
				margin-bottom: 20px;
			}

			.serv_box {
				box-shadow: none;
				background: none;

				.serv_wrap {
					width: 100%;

					.serv_item:first-child {
						padding-right: 0;
					}
				}
			}
		}

		@media (max-width: 767px) {
			.category_top_banner {
				height: 78vh;
				margin-bottom: 4em;

				.container {
					height: 100%;
					justify-content: flex-end;
					padding-bottom: 20px;

					h1.title {
						font-size: 40px;
						padding-left: 15%;
					}

					.banner-text {
						font-size: 16px;
						line-height: 20px;
					}

					.red-btn {
						font-size: 17px;
					}
				}
			}

			.blocks {
				.block {
					display: flex;
					flex-direction: column-reverse;
					text-align: center;
					flex: 0 0 100%;
					max-width: 100%;
					min-height: 0;
					padding: 30px 10px;

					.block-image {
						height: 140px !important;
						object-fit: contain;
						margin: 20px 0 0;
					}

					.block-content {
						.block-title {
							font-size: 28px;
							line-height: 30px;
						}

						.block-text {
							font-size: 14px;
							text-align: center;
							line-height: 18px;
						}
					}

					&:first-child .block-bg-image {
						transform: rotateZ(180deg) rotateY(180deg);
						object-position: 34% 0 !important;
					}
				}
			}

			.page-bottom {
				padding: 20px 25px;

				&:before {
					position: relative;
					display: block;
					height: 63px;
					right: 0;
					left: 0;
					width: 100%;
					top: 0;
					margin-bottom: 20px;
				}

				.bottom-title {
					text-align: center;
					font-size: 18px;
					line-height: 25px;
				}
			}
		}
	}
</style>
<style lang="scss">
	div#page.BusinessLP {
		overflow-x: hidden;

		.contact_form {
			max-width: 100%;

			.row {
				margin: 0 -10px;

				.col-sm-6 {
					padding: 0 10px;
				}
			}

			select {
				width: 100%;
				height: 43px;
				border: 1px solid #c2c2c2;
				font-size: 14px;
				color: #222;
			}

			textarea {
				height: 90px;
			}

			.red-btn {
				input {
					margin-top: -20px;
					border: 1px solid transparent;
					background-color: #ef4134;
					background-position: center;
					color: #ffffff;
					font-size: 20px;
					align-self: flex-start;
					display: flex;
					align-items: center;
					gap: 10px;
					border-radius: 10px;
					padding: 11px 20px;
					transition: 300ms ease background-color, color;
					transform: translateY(-15px);

					&:hover {
						background: #c9372c;
					}
				}

				&.loading input {
					background-image: url(/wp-content/themes/carmella/assets/img/layout/ajax-loader-white.gif);
					background-size: 30px;
					background-position: center;
					background-repeat: no-repeat;
					color: transparent;
				}
			}
		}

		.testimonial-block {
			.slick-slider {
				height: 100%;
			}

			.slick-list {
				height: 100% !important;
			}

			.slick-track {
				height: 100% !important;
			}

			.slick-slide > div {
				height: 100%;
			}

			.testimonial-item-container {
				height: 100%;
				display: flex !important;
				align-items: center;
				text-align: center;

				.text {
					color: #1e824c;
					font-size: 50px;
					font-style: normal;
					font-weight: 300;
					line-height: 1;
					margin-bottom: 20px;
					font-family: "raanancondensed", arial, sans-serif;
				}

				.name {
					color: #000;
					text-align: center;
					font-size: 20px;
					font-style: normal;
					font-weight: 700;
					line-height: 30px; /* 150% */
				}

				@media (max-width: 767px) {
					.text {
						font-size: 40px;
					}
					.name {
						font-size: 16px;
					}
				}
			}

			.slick-dots {
				bottom: 17px;
				position: relative;
			}
		}

		.block-text a {
			color: #000;
			text-decoration: underline;
			font-weight: bold;
			margin-top: 5px;
			display: block;
			transition: 300ms ease all;

			&:hover {
				opacity: 0.8;
			}
		}

		.sent {
			.img {
				float: right;
				margin-left: 5px;

				svg {
					height: 10px;
				}
			}
		}
    .center-button {
      display: flex;
      justify-content: center;
      .btn {
        align-self: center;
      }
    }
		.images-slider {
			margin: 4em 0 7em;

			.slick-list.draggable {
				overflow: visible;
			}

			.slider-item {
				border-radius: 30px;
				background: #fedba6;
				box-shadow: 0 4px 4px -3px rgba(0, 0, 0, 0.25);
				padding: 5px;
				margin: 7px;

				.slider-item-inner {
					height: 280px;
					border: 1px solid #fff;
					border-radius: 26px;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 30px;

          @media (min-width: 1024px) and (max-width: 1440px) {
            padding: 0;
          }
          @media (max-width: 480px) {
            height: 190px;
            padding: 0;
          }
				}

				img {
					width: 90%;
				}
			}

			ul.slick-dots {
				bottom: -50px;
			}
		}
	}

	@media (max-width: 767px) {
		body {
			background: #efede9;
		}
		div#page.BusinessLP {
			.bottom-title br {
				display: none;
			}

			.serv_box.clearfix {
				margin-bottom: 2em;
			}

			.serv_wrap.clearfix {
				display: flex;
				flex-wrap: wrap;

				.serv_item {
					width: 100%;
					flex: 1 0 50%;

					.serv_tx {
						display: block;
					}

					&:nth-child(1) {
						border-bottom: 1px solid #efede9;
						padding-bottom: 10px;
						position: relative;

						&:before {
							content: "";
							position: absolute;
							top: 15px;
							bottom: 15px;
							left: 0;
							width: 1px;
							background: #efede9;
						}
					}

					&:nth-child(2) {
						border-bottom: 1px solid #efede9;
						padding-bottom: 10px;
					}
				}
			}

			.contact_form .red-btn input {
				margin: 1em auto 0;
			}

			.main.page {
				padding-bottom: 5em;
			}
		}
	}
</style>
